import React, {Component} from "react";
import {InitEdgesAction, SetEdgesTensionAction} from "../../store/actions";
import store from "../../store"
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import {generateNodesData, getBezierEdgesParseByEdgeList} from "../../utils";
import {Division} from "../../data/Division";
import nodesDataList from "../../data/nodeData.json";
import edgesData from "../../data/edgesTotal.json";
import {bezierEdge} from "../../store/model";
import './slider.css'

interface props {
    dimension: { height: number, width: number }
    setEdgesTension: (newState: number) => SetEdgesTensionAction;
    initEdges: (newState: Array<bezierEdge>) => InitEdgesAction;
}

interface state {
    value: number
}


class TensionSlider extends Component<props> {
    public state: state;

    constructor(props: props) {
        super(props);
        this.state = {value: store.getState().EdgesData.EdgesTension};
    }

    render() {
        const scale = this.props.dimension.width / 2105;

        const onSliderChange = (value: number) => {
            this.setState({state: value})
            const {setEdgesTension, initEdges} = this.props;
            const {height, width} = this.props.dimension;
            const scale = width / 3840;
            setEdgesTension(value);
            let nodesData = generateNodesData(Division, nodesDataList, height * 0.03, height * 0.85, value / 100, scale)
            let edgesParse = getBezierEdgesParseByEdgeList(nodesData, Array.from(new Set(edgesData)), store.getState().EdgesData.EdgesType, {
                height,
                width
            }, value / 100);
            initEdges(edgesParse);
        }
        return (
            <div className='slider_container'>
                <div className='NunitoText' style={
                    {
                        width: "30%",
                        color: "#AAA",
                        top: '50%',
                        position: 'absolute',
                        transform: 'translate(0, -50%)',
                    }
                }>bundling tension
                </div>
                <div
                    className='slider_main'>
                    <Slider
                        min={0}
                        max={100}
                        value={store.getState().EdgesData.EdgesTension}
                        onChange={onSliderChange}
                        railStyle={{
                            height: 12 * scale
                        }}
                        handleStyle={{
                            height: 20 * scale,
                            width: 20 * scale,
                            marginTop: -4 * scale,
                            backgroundColor: "#333",
                            border: 0
                        }}
                        trackStyle={{
                            background: "none"
                        }}
                    />
                </div>
                <div className='NunitoText' style={
                    {
                        width: "25%",
                        color: "#AAA",
                        position: "absolute",
                        left: '80%',
                        textAlign: 'center',
                        top: '50%',
                        transform: 'translate(0, -50%)',
                    }
                }>{store.getState().EdgesData.EdgesTension}</div>
            </div>
        );
    }
}


export default TensionSlider;